function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.8,
  cx: 22,
  cy: 22,
  r: 22,
  fill: "#F7F7F7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 20.702C14 17.008 17.008 14 20.702 14s6.703 3.008 6.703 6.702a6.676 6.676 0 01-1.534 4.257l3.939 3.932a.65.65 0 01-.919.919l-3.932-3.94a6.676 6.676 0 01-4.257 1.534c-3.694 0-6.702-3.008-6.702-6.702zm12.107 0a5.395 5.395 0 00-5.405-5.405 5.395 5.395 0 00-5.405 5.405 5.395 5.395 0 005.405 5.405 5.395 5.395 0 005.405-5.405z",
  fill: "#333"
});

function SvgCustomCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjgiIGN4PSIyMiIgY3k9IjIyIiByPSIyMiIgZmlsbD0iI0Y3RjdGNyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0IDIwLjcwMjNDMTQgMTcuMDA4MiAxNy4wMDgyIDE0IDIwLjcwMjMgMTRDMjQuMzk2MyAxNCAyNy40MDQ3IDE3LjAwODEgMjcuNDA0NyAyMC43MDIxQzI3LjQwNDcgMjIuMzE2IDI2LjgyNjIgMjMuOCAyNS44NzEgMjQuOTU4N0wyOS44MSAyOC44OTA5QzMwLjA2MzMgMjkuMTQ0MyAzMC4wNjMzIDI5LjU1NjQgMjkuODEgMjkuODA5OEMyOS41NTY2IDMwLjA2MzIgMjkuMTQ0NSAzMC4wNjMyIDI4Ljg5MTEgMjkuODA5OEwyNC45NTg4IDI1Ljg3MDhDMjMuOCAyNi44MjYgMjIuMzE2MiAyNy40MDQ1IDIwLjcwMjMgMjcuNDA0NUMxNy4wMDgyIDI3LjQwNDUgMTQgMjQuMzk2MyAxNCAyMC43MDIzWk0yNi4xMDczIDIwLjcwMjNDMjYuMTA3MyAxNy43MDkyIDIzLjY5NTQgMTUuMjk3MiAyMC43MDIzIDE1LjI5NzJDMTcuNzA5MiAxNS4yOTcyIDE1LjI5NzIgMTcuNzA5MiAxNS4yOTcyIDIwLjcwMjNDMTUuMjk3MiAyMy42OTUzIDE3LjcwOTIgMjYuMTA3MyAyMC43MDIzIDI2LjEwNzNDMjMuNjk1NCAyNi4xMDczIDI2LjEwNzMgMjMuNjk1MyAyNi4xMDczIDIwLjcwMjNaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo=";
export { SvgCustomCursor as ReactComponent };